import PageBuilder from '../pageBuilder/PageBuilder';

export default {

  name: 'Advantages',

  components: {
    'page-builder': PageBuilder
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/advantages/Advantages.js